import { add, dot, lenSq, scale, sub, type Vec2 } from './vec2';

/**
 * Where `p` projects onto the line through `origin` along `direction`, as a multiple of
 * `direction`; null when the direction has no length.
 */
export function projectParameter(origin: Vec2, direction: Vec2, p: Vec2): number | null {
  const lengthSq = lenSq(direction);
  if (lengthSq === 0) return null;
  return dot(sub(p, origin), direction) / lengthSq;
}

/** Closest point to `p` on the ray that starts at `origin` and runs along `direction`. */
export function closestPointOnRay(origin: Vec2, direction: Vec2, p: Vec2): Vec2 {
  const t = projectParameter(origin, direction, p);
  if (t === null) return origin;
  return add(origin, scale(direction, Math.max(0, t)));
}
